const Footer = () => {
  return (
    <div className="Footer">
      <div>Developed by Mudit Dahiya</div>
    </div>
  );
};

export default Footer;
